import {createAsyncThunk} from '@reduxjs/toolkit'

import {PAY} from '@web/core/urls'
import {changeBrowserLocation} from '@web/helpers/browser'

import {LocationChangeHistoryParam, ThunkApi} from '../interfaces'

/**
 * 페이/결제탭 홈으로 이동
 * - 기본 이동 방식은 `PUSH` 입니다.
 */
const navigateToPaymentHome = createAsyncThunk<void, LocationChangeHistoryParam | void, ThunkApi>(
    'navigateTo/paymentHome',
    async (args) => {
        const {historyType = 'PUSH'} = args ?? {}

        changeBrowserLocation({url: `${PAY}/historybenefit/home`, type: historyType})
    },
)

export default navigateToPaymentHome
